import {WebConfig} from "~/src/Model/WebConfig/WebConfig";

export const BaseWebConfig: WebConfig = {
    apiUrl: 'https://www.pixelnia.com/api'
}